import React from "react";
export default (function () {
    return React.createElement("svg", { width: "24", height: "22", viewBox: "0 0 24 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { y: "20", width: "24", height: "2", fill: "currentColor" }),
        React.createElement("rect", { y: "16", width: "24", height: "2", fill: "currentColor" }),
        React.createElement("rect", { y: "12", width: "24", height: "2", fill: "currentColor" }),
        React.createElement("rect", { y: "8", width: "24", height: "2", fill: "currentColor" }),
        React.createElement("rect", { y: "4", width: "24", height: "2", fill: "currentColor" }),
        React.createElement("rect", { width: "24", height: "2", fill: "currentColor" }));
});
//# sourceMappingURL=high-density.js.map